module.exports = __webpack_public_path__ + "img/success-toaster.f3a2a68.svg";